module.exports = __webpack_public_path__ + "static/media/3.87337c46.jpg";